/**
 * Vue 3 removed `vm._uid` (Vue 2's internal incrementing component ID).
 * `nextUid()` is the migration shim — call it once in `data()` or `created()`
 * and store the result on the instance so subsequent `this.uid` reads are
 * stable per component.
 *
 *   data() { return { uid: nextUid() } }
 *   // template / methods use `this.uid` instead of `this._uid`
 *
 * Module-scope counter; monotonically increasing across the page lifetime.
 */
let counter = 0

export function nextUid() {
    counter += 1
    return counter
}

export default nextUid
